import { Link } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { INQUIRY_STATUS_LABELS, type Inquiry, type Paginated } from '@kontor/shared';
import { api } from '../../api';
import { useSession } from '../../session';
import './contacts.css';

const dateFormat = new Intl.DateTimeFormat('de-DE', { dateStyle: 'medium' });

/** Anfragen, die diesem Kontakt zugeordnet sind. Erscheint nur, wenn das Modul Anfragen lizenziert ist und die Rolle es lesen darf. */
export function ContactInquiries({ contactId }: { contactId: string }) {
  const { can, hasModule } = useSession();
  const allowed = hasModule('inquiries') && can('inquiries.read');
  const list = useQuery({
    queryKey: ['contact-inquiries', contactId],
    queryFn: () => api<Paginated<Inquiry>>('GET', `/inquiries?contactId=${contactId}&perPage=50`),
    enabled: allowed,
  });
  if (!allowed) return null;

  return (
    <section className="card">
      <h2>Anfragen</h2>
      {list.isLoading && <p className="muted">Wird geladen …</p>}
      {list.isError && <p className="muted">Die Anfragen konnten nicht geladen werden.</p>}
      {list.data?.data.length === 0 && <p className="muted">Diesem Kontakt ist noch keine Anfrage zugeordnet. Das geschieht in der jeweiligen Anfrage.</p>}
      {list.data && list.data.data.length > 0 && (
        <ul className="contact-inquiries">
          {list.data.data.map((i) => (
            <li key={i.id}>
              <Link to={`/anfragen/${i.id}`} className="strong-link">{i.reference}</Link>
              <span className="badge">{INQUIRY_STATUS_LABELS[i.status]}</span>
              <span className="muted small">{dateFormat.format(new Date(i.createdAt))}</span>
            </li>
          ))}
        </ul>
      )}
      {list.data && list.data.meta.total > list.data.data.length && <p className="muted small">Es werden die ersten {list.data.data.length} von {list.data.meta.total} Anfragen angezeigt.</p>}
    </section>
  );
}
